// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';

export const triggerFetchAvailableApps = createAction('appSelector/fetchAllApps', () => ({
	payload: {}
}));
export const triggerFetchAvailableWorkflows= createAction('appSelector/fetchAllWorkflows', () => ({
	payload: {}
}));
